import { render, staticRenderFns } from "./HomeGeneralTab.vue?vue&type=template&id=1a8f14ba&scoped=true&"
import script from "./HomeGeneralTab.vue?vue&type=script&lang=js&"
export * from "./HomeGeneralTab.vue?vue&type=script&lang=js&"
import style0 from "./HomeGeneralTab.vue?vue&type=style&index=0&id=1a8f14ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8f14ba",
  null
  
)

export default component.exports